import { useState } from 'react';

type PhoneMockupProps = {
  screenshotSrc: string;
  screenshotAlt: string;
  className?: string;
};

export function PhoneMockup({ screenshotSrc, screenshotAlt, className = '' }: PhoneMockupProps) {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <div
      className={`relative mx-auto w-[min(72vw,16.5rem)] sm:w-[min(100%,19rem)] md:w-[min(100%,20.5rem)] ${className}`}
      aria-hidden={imageFailed}
    >
      <div className="relative rounded-[2.25rem] sm:rounded-[2.75rem] border-[6px] sm:border-[10px] border-[#111818] bg-[#111818] shadow-[0_24px_60px_rgba(17,24,24,0.18)] overflow-hidden">
        <div className="absolute left-1/2 top-0 z-10 h-5 sm:h-6 w-24 sm:w-28 -translate-x-1/2 rounded-b-2xl bg-[#111818]" />
        <div className="aspect-[470/1024] w-full bg-[#111818]">
          {imageFailed ? (
            <div className="flex h-full flex-col items-center justify-center gap-2 px-6 text-center bg-[#f0f4f4]">
              <p className="font-display text-lg text-[#111818]">Screenshot preview</p>
              <p className="text-sm text-[#638888]">
                Add <code className="text-xs">{screenshotSrc}</code> to show this feature.
              </p>
            </div>
          ) : (
            <img
              src={screenshotSrc}
              alt={screenshotAlt}
              className="block h-full w-full object-contain"
              loading="lazy"
              decoding="async"
              onError={() => setImageFailed(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
